<template>
  <div class="flex-grow-1">
    <div class="a-header">
      <span class="a-header--title">Compare Differences</span>
      <div>
        <a-button size="default" class="a-header--button success-btn" :disabled="isDisableDownloadFile" @click="download"> <a-icon type="cloud-download" /> Download </a-button>
      </div>
    </div>
    <div class="a-body">
      <div>
        <div>
          <a-select :value="initValueSelectType" class="selectbox-type" placeholder="Select Value" @change="handleChangeType">
            <template v-for="(filesName, groupName) in selectOptionsTypeToCompare">
              <a-select-opt-group :key="groupName">
                <span slot="label" class="text-uppercase form-label">{{ groupName }}</span>
                <template v-for="fileName in filesName">
                  <a-select-option :key="fileName" :value="fileName">
                    {{ fileName }}
                  </a-select-option>
                </template>
              </a-select-opt-group>
            </template>
          </a-select>
          
          <template>
            <a-dropdown :placement="bottomCenter" :trigger="['click']" style="float:right">
              <a-menu slot="overlay">
                <a-sub-menu key="view" title="Comparison View">
                  <a-menu-item 
                    key="1" 
                    @click="setCurrentOutputFormatValue('side-by-side')" 
                    :selected="currentOutputFormatValue === 'side-by-side'">
                    <a-icon type="check" v-if="currentOutputFormatValue === 'side-by-side'" />
                    <a-icon style="opacity: 0;" type="check" v-else="currentOutputFormatValue != 'side-by-side'"/>
                    Side-By-Side
                  </a-menu-item>
                  <a-menu-item 
                    key="2" 
                    @click="setCurrentOutputFormatValue('line-by-line')" 
                    :selected="currentOutputFormatValue === 'line-by-line'">
                    <a-icon type="check" v-if="currentOutputFormatValue === 'line-by-line'" />
                    <a-icon style="opacity: 0;" type="check" v-else="currentOutputFormatValue != 'line-by-line'"/>
                    Line-By-Line
                  </a-menu-item>
                </a-sub-menu>
                <a-sub-menu key="context" title="Lines Context">
                  <a-menu-item key="3" @click="setContextValue(5)"> 
                    <a-icon type="check" v-if="contextValue === 5" />
                    <a-icon style="opacity: 0;" type="check" v-else="contextValue != 5"/>
                    5 
                  </a-menu-item>
                  <a-menu-item key="4" @click="setContextValue(15)"> 
                    <a-icon type="check" v-if="contextValue === 15"/>
                    <a-icon style="opacity: 0;" type="check" v-else="contextValue != 15"/>
                    15 
                  </a-menu-item>
                  <a-menu-item key="5" @click="setContextValue(100)"> 
                    <a-icon type="check" v-if="contextValue === 100" />
                    <a-icon style="opacity: 0;" type="check" v-else="contextValue != 100"/>
                    100 
                  </a-menu-item>
                </a-sub-menu>
                <a-menu-divider />
                <a-menu-item key="6" @click="toggleBeautifyCode"> <a-icon type="check" v-if="isBeautifyCodeEnabled" />Beautify Code </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px"> Code Format Options <a-icon type="down" /> </a-button>
            </a-dropdown>
          </template>
        </div>
        <div class="d-flex justify-content-between mt-3 mb-2">
          <div class="selectbox-version">
            <div>
              <a-select placeholder="Select Value" :value="initValueSelectVersionLeftBlock" :disabled="!currentFileSelect" @change="(e) => handleChangeVersionToCompare(e, 'left')">
                <template v-for="version in selectOptionCompareFiles">
                  <a-select-option :key="version" :value="version" v-if="version !== initValueSelectVersionRightBlock && version !== 'file_type'">{{ replaceLabelOption(version) }}</a-select-option>
                </template>
              </a-select>
            </div>
          </div>
          <div class="selectbox-version">
            <div>
              <a-select placeholder="Select Value" :value="initValueSelectVersionRightBlock" :disabled="!currentFileSelect" @change="(e) => handleChangeVersionToCompare(e, 'right')">
                <template v-for="version in selectOptionCompareFiles">
                  <a-select-option :key="version" :value="version" v-if="version !== initValueSelectVersionLeftBlock && version !== 'file_type'">{{ replaceLabelOption(version) }}</a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-if="(currentCodeLeftBlockValue || currentCodeRightBlockValue) && !isRenderComparison">
        <p class="mb-0"><a-icon type="sync" spin /> Comparing...</p>
      </div>
      <div v-if="(currentCodeLeftBlockValue || currentCodeRightBlockValue) && isRenderComparison">
        <CodeDiff :oldString="currentCodeLeftBlockValue" :newString="currentCodeRightBlockValue" :beautify="beautifyValue" :outputFormat="currentOutputFormatValue" :context="contextValue" />
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import beautify from 'js-beautify';
  import { DATE_FORMAT } from '@constants/dateFormat';
  import { API_URL } from '@shared/services/api.service';
  import IncidentService from '../services/Incident.service';
  import CodeDiff from '@shared/components/CodeDiff';

  export default {
    name: 'IncidentComparison',
    components: {
      CodeDiff
    },
    data() {
      return {
        incidentDetail: {
          id: '',
          js: {},
          css: {},
          html: {}
        },
        incidentDetailFlatObj: {},
        metaData: {},
        selectOptionsTypeToCompare: {},
        selectOptionCompareFiles: {},
        currentFileSelect: '',
        currentCodeLeftBlockValue: '',
        currentCodeRightBlockValue: '',
        initValueSelectType: '',
        initValueSelectVersionLeftBlock: '',
        initValueSelectVersionRightBlock: '',
        isRenderComparison: false,
        isDisableDownloadFile: false,
        initFileToCompare: '',
        staticFileComparison: null,
        verifyResult: null,
        isBeautifyCodeEnabled: false,
        beautifyValue: "",
        currentOutputFormatValue: 'side-by-side',
        contextValue: 5
      };
    },
    computed: {
      replaceLabelOption() {
        return (key) => {
          let label = key;
          switch (key) {
            case 'previous_incident': {
              label = 'Last Alert';
              if (this.metaData['previous_incident']) {
                label += ` (${moment(this.metaData['previous_incident'].time).format(DATE_FORMAT.FULL_DATE)}) - Alert ID ${this.metaData['previous_incident'].id}`;
              }
              break;
            }
            case 'incident': {
              label = 'Current Verification';
              if (this.metaData['incident']) {
                label += ` (${moment(this.metaData['incident'].time).format(DATE_FORMAT.FULL_DATE)}) - Alert ID ${this.metaData['incident'].id}`;
              }
              break;
            }
            case 'baseline': {
              label = 'Original Baseline';
              if (this.metaData['baseline']) {
                label += ` (${moment(this.metaData['baseline'].time).format(DATE_FORMAT.FULL_DATE)})`;
              }
              break;
            }
          }
          return label;
        };
      }
    },
    beforeMount() {
      this.incidentDetail.id = this.$route.params.id;
      this.initFileToCompare = (location.hash || '').replace('#', '');
    },
    mounted() {
      this.initData();
      this.currentOutputFormatValue = window.localStorage.getItem("codeOutputFormat") || 'side-by-side';
      this.isBeautifyCodeEnabled =  window.localStorage.getItem("beautifyCode") === 'true' || false;
      this.contextValue = Number(window.localStorage.getItem('contextValue')) || 5;
    },
    methods: {
      async initData() {
          try {
              await this.fetchIncidentData();
          } catch {
              // Do nothing if we don't have the detailed verify result structured data
          }
          await this.fetchFilesToCompare();
      },
      async fetchIncidentData() {
          const incidentDetail = await IncidentService.fetchDetailIncident(this.incidentDetail.id);
          let verify_record = incidentDetail.verify_record;
          const verifyResult = (await IncidentService.fetchDetailVerify(verify_record.id));
          this.verifyResult = verifyResult ? verifyResult.structured_result : null;
      },
      async fetchFilesToCompare() {
        try {
          const filesResponse = await IncidentService.fetchFilesToCompare(this.incidentDetail.id);
          const { js, css, html, metadata } = filesResponse;
          this.metaData = metadata;
          this.incidentDetail.js = js;
          this.incidentDetail.css = css;
          this.incidentDetail.html = html;

          for (const key in js) {
            js[key].file_type = "js";
          }

          for (const key in css) {
            css[key].file_type = "css";
          }

          for (const key in html) {
            html[key].file_type = "html";
          }

          this.incidentDetailFlatObj = { ...js, ...css, ...html };

          this.selectOptionsTypeToCompare = ['html', 'css', 'js'].reduce((result, key) => {
            const keysOfSingleType = filesResponse[key] && Object.keys(filesResponse[key]);
            if (keysOfSingleType && keysOfSingleType.length) {
              result[key] = keysOfSingleType;
            }
            return result;
          }, {});

          if (html) {
            const keyHtmlFiles = Object.keys(html);
            this.initValueSelectType = this.initFileToCompare ? this.initFileToCompare : keyHtmlFiles && keyHtmlFiles[0] ? keyHtmlFiles[0] : '';
            this.handleChangeType(this.initValueSelectType);
          } else if (js) {
            const keyJsFiles = Object.keys(js);
            this.initValueSelectType = this.initFileToCompare ? this.initFileToCompare : keyJsFiles && keyJsFiles[0] ? keyJsFiles[0] : '';
            this.handleChangeType(this.initValueSelectType);
          } else if (css) {
            const keyCssFiles = Object.keys(css);
            this.initValueSelectType = this.initFileToCompare ? this.initFileToCompare : keyCssFiles && keyCssFiles[0] ? keyCssFiles[0] : '';
            this.handleChangeType(this.initValueSelectType);
          }

        } catch (error) {
          console.log(error);
          this.$showErrorMessage('Error when loading files');
          this.$router.push(`/incident/detail/${this.incidentDetail.id}`);
        }
      },
      async download() {
        this.isDisableDownloadFile = true;
        try {
          const { url } = await IncidentService.fetchUrlFileToDownload(this.incidentDetail.id);
          const linkTag = document.createElement('a');
          linkTag.href = `${API_URL}${url.replace(/api\//i, '')}`;
          document.body.appendChild(linkTag);
          linkTag.click();
          document.body.removeChild(linkTag);
        } catch (error) {
        } finally {
          setTimeout(() => {
            this.isDisableDownloadFile = false;
          }, 2000);
        }
      },
      async handleChangeType(value) {
        if (this.initValueSelectType !== value) {
          this.initValueSelectType = value;
        }
        this.currentCodeLeftBlockValue = '';
        this.currentCodeRightBlockValue = '';
        this.currentFileSelect = value;
        const isExistFileCompare = this.incidentDetailFlatObj[value];
        this.selectOptionCompareFiles = isExistFileCompare ? Object.keys(this.incidentDetailFlatObj[value]).filter((key) => key !== 'valuesFile') : [];
        if (isExistFileCompare) {
          const isHasValue = Object.prototype.hasOwnProperty.call(this.incidentDetailFlatObj[value], 'valuesFile');
          const versionKeys = Object.keys(this.incidentDetailFlatObj[value]);
          if (!isHasValue) {
            this.incidentDetailFlatObj[value]['valuesFile'] = {};
            for (let index = 0; index < versionKeys.length; index++) {
              const version = versionKeys[index];
              this.incidentDetailFlatObj[value]['valuesFile'][version] = await this.fetchValuesFiles(this.incidentDetailFlatObj[value][version]);
            }
          }
        }
        this.initValueSelectVersionRightBlock = 'incident';
        this.handleChangeVersionToCompare(this.initValueSelectVersionRightBlock, 'right');

        let initValueSelectVersionLeftBlockPriority = ['previous_incident', 'baseline'];
        if (this.metaData.previous_incident && this.metaData.baseline) {
          if (this.metaData.baseline > this.metaData.previous_incident) {
            // We prefer the later one
              initValueSelectVersionLeftBlockPriority = ['baseline', 'previous_incident'];
          }
        }

        // If we have the verify result, we check what the comparison was and then use that to determine what to show
        if (this.verifyResult) {
            if (this.verifyResult.url_status === "CRITICAL" && this.verifyResult.new_url_status === "CRITICAL") {
                initValueSelectVersionLeftBlockPriority = ['previous_incident', 'baseline'];
            } else if (this.verifyResult.url_status === "WARNING" && this.verifyResult.new_url_status === "CRITICAL") {
                initValueSelectVersionLeftBlockPriority = ['baseline', 'previous_incident'];
            }
        }

        // Either way, if either one doesn't exist we just show the other one
        this.initValueSelectVersionLeftBlock = initValueSelectVersionLeftBlockPriority[0];
        if (this.incidentDetailFlatObj[this.currentFileSelect].valuesFile[this.initValueSelectVersionLeftBlock]) {
          // the preferred option exists, so we use it
        } else {
          // else we switch to the second option
          this.initValueSelectVersionLeftBlock = initValueSelectVersionLeftBlockPriority[1];
        }
        this.handleChangeVersionToCompare(this.initValueSelectVersionLeftBlock, 'left');
      },
      async fetchValuesFiles(urlFile) {
        try {
          const response = await fetch(urlFile);
          const file = await response.text();
          return file;
        } catch {
          this.$showErrorMessage('Error when loading files');
        }
      },
      handleChangeVersionToCompare(version, block) {
        this.isRenderComparison = false;
        if (block === 'left') {
          this.initValueSelectVersionLeftBlock = version;
          let code = this.incidentDetailFlatObj[this.currentFileSelect].valuesFile[version];
          if (this.isBeautifyCodeEnabled) {
            this.beautifyValue = this.incidentDetailFlatObj[this.currentFileSelect].file_type;
          } else {
            this.beautifyValue = "";
          }
          this.currentCodeLeftBlockValue = code;
        } else {
          this.initValueSelectVersionRightBlock = version;
          let code = this.incidentDetailFlatObj[this.currentFileSelect].valuesFile[version];
          if (this.isBeautifyCodeEnabled) {
            this.beautifyValue = this.incidentDetailFlatObj[this.currentFileSelect].file_type;
          } else {
            this.beautifyValue = "";
          }
          this.currentCodeRightBlockValue = code;
        }
        setTimeout(() => {
          this.isRenderComparison = true;
        });
      },
      toggleBeautifyCode() {
        this.isBeautifyCodeEnabled = !this.isBeautifyCodeEnabled;
        window.localStorage.setItem("beautifyCode", this.isBeautifyCodeEnabled);
        this.handleChangeVersionToCompare(this.initValueSelectVersionLeftBlock, 'left');
        this.handleChangeVersionToCompare(this.initValueSelectVersionRightBlock, 'right');
      },
      setCurrentOutputFormatValue(value){
        this.currentOutputFormatValue = value;
        window.localStorage.setItem("codeOutputFormat", this.currentOutputFormatValue);
      },
      setContextValue(value){
        this.contextValue = value;
        window.localStorage.setItem("contextValue", this.contextValue);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .a-header--button {
    padding: 6px 20px;
    border-radius: 4px;
    font-size: 11px;
    line-height: 16px;
    &.success-btn {
      background-color: #04b0ed;
      color: #ffffff;
    }
  }
  .a-body {
    padding: 20px;
    height: calc(100% - 60px);
  }
  .selectbox-type,
  .selectbox-version {
    width: 50%;
    min-width: 400px;
    max-width: 600px;
  }

  .code-container {
    padding: 1rem;
    background-color: #e8e8e8;
    border-radius: 4px;
    overflow-x: auto;
  }
  .code-box {
    pre {
      overflow: visible;
    }
  }
  .compare-container {
    overflow-y: auto;
    height: calc(100% - 125px);
  }
</style>
